import { c as _c } from "react/compiler-runtime";
import ButtonId from "@lib/buttonId";
import { FATHOM_CLICK_EVENTS } from "@lib/constants";
import { isProd, isTest } from "@lib/settings";
import { useRouter } from "@lib/hooks/useRouter";
import { useEffect } from "react";
import { fathom } from "@justhome/common";
const Fathom = () => {
  const $ = _c(7);
  const router = useRouter();
  let t0;
  let t1;
  if ($[0] !== router) {
    t0 = () => {
      if (!router.isReady) {
        return;
      }
      const {
        fathomEvent,
        ...query
      } = router.query;
      if (fathomEvent) {
        fathom.trackEvent(fathomEvent as string);
        router.replace({
          pathname: router.pathname,
          query
        });
      }
    };
    t1 = [router.isReady, router];
    $[0] = router;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = [];
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  useEffect(_temp2, t2);
  let t3;
  let t4;
  if ($[4] !== router.events) {
    t3 = () => {
      const onRouteChangeComplete = function onRouteChangeComplete() {
        fathom.trackPageview();
      };
      const isEnabled = !isTest;
      if (isEnabled) {
        router.events.on("routeChangeComplete", onRouteChangeComplete);
      }
      return () => {
        if (isEnabled) {
          router.events.off("routeChangeComplete", onRouteChangeComplete);
        }
      };
    };
    t4 = [router.events];
    $[4] = router.events;
    $[5] = t3;
    $[6] = t4;
  } else {
    t3 = $[5];
    t4 = $[6];
  }
  useEffect(t3, t4);
  return null;
};
export default Fathom;
function _temp(event) {
  const eventName = FATHOM_CLICK_EVENTS[(event.target as HTMLElement)?.id as ButtonId];
  if (eventName) {
    if (!isProd) {
      console.log("Fathom: tracking event", eventName);
    }
    fathom.trackEvent(eventName);
  }
}
function _temp2() {
  const handleClick = _temp;
  document.body.addEventListener("click", handleClick);
  return () => {
    document.body.removeEventListener("click", handleClick);
  };
}